angular.module('natgeo').controller('Level1LearnScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'SoundEngine', 'CommonFunctions', 'ScreenView',
function Level1LearnScreen($scope, element, ScreenFactory, manager, container, SoundEngine, CommonFunctions, ScreenView)
{
	var screen = ScreenFactory( 'level1_learn', element );

	// Store the current state so it can be restored later.
	screen.store();

	// How many times the screen has reloaded
	screen.loads = 0;
	
	var gearDescription = [
		'Great job! Now add the second step.',
		'Good work. Pull in the third step now.',
		'Great! Now add the fourth step.',
		'You are almost done! Add the fifth step.',
		'Excellent! Now add the final step.',
		''
	];
	var gearHints = [
		'HINT: Decide on a problem to solve.',
		'HINT: Research how to solve the problem.',
		'HINT: Decide how to create a solution.',
		'HINT: Create the solution.',
		'HINT: Ensure that the solution works properly.',
		'HINT: Iterate the solution to make it work even better.'
	];

	// Reload the state of the screen when we come back to it.
	screen.on('introBefore', function()
	{
		if ( screen.loads > 0 )
		{
			// Restore screen to initial values
			screen.restore( ScreenView, container, $scope.$new( false ) );
		}

		// Grab them gears!
		screen.gears = screen.view.find('.gear');
		screen.gearTexts = screen.view.find('.gear-text');
		screen.gearHoles = screen.view.find('.gear-hole');
		screen.gearFinal = screen.view.find('.gear-final');

		// Initialize Draggables
		screen.gears.draggable(
		{
			containment: screen.view,
			distance: 0,
			revert: true,
			start: function(e, ui)
			{
				this.style.zIndex = 100;
			}
		});

		// Initialize Droppables
		screen.gearHoles.each( screen.initializeDroppable );

		// Randomize!
		screen.randomizeGears();

		// Sets the helper text
		screen.setHelperText = CommonFunctions.setHelperText( screen._helperText, screen._helperBox );

		// Loaded!
		screen.loads++;
	});

	// When the intro stops, pulse the current gear hole
	screen.on('introEnd', function()
	{
		screen.gearHoles.filter('.active').last().play('infinite pulse');
	});

	// Randomize
	screen.randomizeGears = function()
	{
		CommonFunctions.shuffleElements( screen.gears, container );
	};

	// Initializes a single droppable
	screen.initializeDroppable = function(index, element)
	{
		var hole = $(element);
		var gear = screen.sprite( hole.data('accept') );
		var text = screen.sprite( hole.data('text') );

		hole.droppable(
		{
			tolerance: 'touch',

			drop: function(e, ui)
			{
				if (hole.hasClass('active') && !ui.draggable.done)
				{
					if (!ui.draggable.is( gear ))
					{
						screen.setHelperText( gearHints[ index ] );

						return;
					}

					// Mark it as done so accidental intersections don't trigger hints.
					ui.draggable.done = true;

					// Drop dat gear!
					screen.onGearDrop( hole, gear, text, ui.position );	
				}
			}
		});
	};

	// Invoked when a gear is dropped succcesfully on a hole
	screen.onGearDrop = function(hole, gear, text, position)
	{
		var gearIndex = parseInt( hole.data('index') );
		var startX = position.left / container.getScale();
		var startY = position.top / container.getScale();
		var endX = hole.data('left');
		var endY = hole.data('top');
		var gearNew = gear.clone();

		gearNew
			.removeAttr('anim8')
			.removeAttr('style')
			.removeClass('ui-draggable ui-draggable-dragging selectable')
			.removeAttr('data-intro')
			.removeAttr('data-outro')
			.removeData()
			.data('left', endX)
			.data('top', endY)
			.data('width', gear.data('width'))
			.data('height', gear.data('height'))
			.data('scale', gear.data('scale'))
			.data('intro', 'fadeInUp')
			.data('outro', 'fadeOutDown')
			.scale( container.getScale() )
		;

		SoundEngine.play( 'gear', {delay:500} );

		gear.after( gearNew ).remove();

		screen.sprites = screen.sprites.add( gearNew );

		var moveAnimation = {
			keyframe: {
				from: {
					translate: {
						x: (startX - endX) * container.getScale(), 
						y: (startY - endY) * container.getScale()
					}
				},
				to: {
					translate: 0
				}	
			},
			durations: {
				translate: 500
			}
		};

		var anim8or = gearNew.animators().first();
		anim8or.play( moveAnimation );

		// Outroduce hole & text
		screen.outroduceMany( hole.stopIt(), 'fadeOut 0.5s' );
		screen.outroduceMany( text.stopIt(), 'fadeOut 0.5s' );

		if ( hole.data('last') )
		{
			screen.onComplete();
		}
		else
		{
			// Tada!
			anim8or.queue( 'tada' );

			// Activate next hole & text
			hole.next().addClass('active').play('pulse infinite');
			text.next().addClass('active').play('pulse infinite');

			// Move the pointer (there will be a better way of doing this - moving an item permanently)	
			var pointer = anim8( screen._gearPointer.data() );
			var pointerAnimation = {
				keyframe: {
					from: {
						left: 346 + gearIndex * 111
					},
					to: {
						left: 457 + gearIndex * 111
					}
				},
				durations: {
					left: 500
				}
			};
			var pointerScale = function() {
				screen._gearPointer.data('left', this.frame.left);
				screen._gearPointer[0].style.left = (this.frame.left * container.getScale()) + 'px';
			};

			pointer
				.play( pointerAnimation )
				.on( 'apply', pointerScale )
				.once( 'finished', function() {
					this.off( 'apply', pointerScale );
				})
			;
			
			// Helper text
			screen.setHelperText( gearDescription[ gearIndex ] );
		}
	};

	// Triggered when all gears have been placed
	screen.onComplete = function()
	{
		screen._prev.play('fadeOut').queueAnimation('fadeIn ~3s');

		screen.outroduce( 'gearPointer', 'bounceOut' );
		screen.outroduce( 'gearSource', 'bounceOut' );
		screen.outroduce( 'helperText', 'fadeOutLeft' );
		screen.outroduce( 'helperBox', 'fadeOutLeft' );
		screen.outroduce( 'helperBot', 'fadeOutLeft' );
		screen.outroduce( 'instructions', 'flipOutX' );
		screen.introduce( 'congrats', 'flipInX' );

		screen.view.find('.conclusion, .conclusion *')
			.removeClass( 'hidden' )
			.dataPlay('intro')
			.applyInitialState()
		;

		screen.outroduceMany( screen.view.find('.gear'), 'fadeOut 0.1s', function()
		{
			$(this).removeClass('hidden').play('fadeIn 0.1s ~3.9s');
		});

		screen.gearFinal
			.removeClass('hidden')
			.each(function(i) {

				var anim8or = anim8( this );

				anim8or.play({
					keyframe: {
						'0': {
							scale: 1
						},
						'10': {
							scale: 1.2,
							rotate: 0,
							easing: 'linear'	
						},
						'90': {
							scale: 1.2,
							rotate: 360 * 3 * ((i % 2) * 2 - 1)
						},
						'100': {
							scale: 1
						}
					}
				}, {
					duration: 4000,
					delay: 500
				});

				anim8or.once('finished', function()
				{
					screen.outroduce( $(this).data('named'), 'fadeOut 0.5s' );

				}, this);

			})
		;

		SoundEngine.play( 'whip' );
		SoundEngine.play( 'gear-loopit', {delay:500, loop:6} );
	};
	
	// The next screen is the learn screen
	$scope.next = function()
	{
		SoundEngine.stopAll();

		manager.transition('level1_reward');
	};
	
	// The previous screen is the office screen
	$scope.prev = function()
	{
		manager.transition('level1_define');
	};
	
	
}]);